import { defineStore } from 'pinia';

export const useNotificationStore = defineStore('notifications', () => {
  const { data, execute } = useGetData<any>();
  const unreadCount = ref<number>(0);

  const fetchUnreadCount = async () => {
    try {
      await execute('notifications/unread-count');

      if (data.value?.count !== undefined) {
        unreadCount.value = data.value.count;
      }
    } catch (error) {
      console.error('Failed to fetch unread count:', error);
    }
  };

  const decrementCount = () => {
    if (unreadCount.value > 0) {
      unreadCount.value--;
    }
  };

  const reset = () => {
    unreadCount.value = 0;
  };

  return {
    unreadCount,
    fetchUnreadCount,
    decrementCount,
    reset,
  };
});
